import type { User } from './user';

export interface MeetingFile {
  key: string;
  file_name?: string;
}

export interface Meeting {
  id: string;
  community_id: string;
  held_on: string | null;
  agenda?: string;
  content: string;
  created_by_id: string;
  created_by?: User;
  meeting_type_id: MeetingTypes;
  meeting_type?: MeetingType;
  files?: MeetingFile[] | null;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
}

export interface MeetingType {
  id: number;
  name: string;
  description: string;
  created_at: string;
  updated_at: string;
}

export const Meeting_Type = {
  1: 'Board',
  2: 'Community',
  3: 'Vendor',
  4: 'Other',
  BOARD: 'Board',
  COMMUNITY: 'Community',
  VENDOR: 'Vendor',
  OTHER: 'Other',
} as const;
export type MeetingTypes = keyof typeof Meeting_Type;
